class NewsLetterForm extends HTMLElement {
  constructor() {
      super();
      this.form = this.querySelector('form');
      this.formPopup = this.form.querySelector('#newsletter-popup');
      this.newsletterFormFooter = document.querySelector('.newsletter-footer_cta');
      this.closeNewsletterDrawer = this.form.closest('side-drawer');
      this.drawerToOpen = document.querySelector('.sidedrawer-container');
  }

  connectedCallback() {
      // Aggiungi l'event listener per chiudere il popup
      document.querySelector('.newsletter-form')?.nextElementSibling?.addEventListener('click', () => {
          this.setNewsletterCookie();
      });

      // Mostra il popup se necessario
      if (this.formPopup && !this.checkNewsletterCookie() && this.newsletterFormFooter.hasAttribute('data-display')) {
          // Ottieni e converti il valore di data-display, se valido usa setTimeout
          const displayTime = parseFloat(this.newsletterFormFooter.dataset.display);
          if (!isNaN(displayTime) && displayTime > 0) {
              setTimeout(() => this.openNewsletterPopup(), displayTime * 1000);
          }
      }

      // Gestisci l'evento di submit del modulo
      this.form.addEventListener("submit", (e) => {
          this.handleSubmit(e);
      });
  }

  // Funzione per verificare se il cookie è presente
  checkNewsletterCookie() {
      return document.cookie.split(';').some((item) => item.trim().startsWith('newsletterPopupClosed='));
  }

  // Funzione per impostare il cookie
  setNewsletterCookie() {
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      document.cookie = 'newsletterPopupClosed=true; expires=' + expiryDate.toUTCString() + '; path=/';
  }

  // Funzione per aprire il popup della newsletter
  openNewsletterPopup() {
      if (this.formPopup) {
        this.newsletterFormFooter.click();
        this.setNewsletterCookie();
      }
  }

  // Funzione per chiudere il popup della newsletter
  closeNewsletterPopup() {
      if (this.formPopup) {
          this.formPopup.style.display = "none"; // Nascondi il popup
      }
  }

  // Funzione per gestire l'evento di submit del modulo
  handleSubmit(e) {
      const formTags = this.form.querySelector('#form_tags');
      const lastName = this.form.querySelector("#last-name");
      const firstName = this.form.querySelector("#first-name").value;
      const phone = this.form.querySelector("#phone");
      const city = this.form.querySelector('#city');
      const countryEl = this.form.querySelector("#country");
      const nameStore = this.form.querySelector('#name_store');

      formTags.value = `newsletter,first-name_${firstName}`;
      const country = countryEl.options[countryEl.selectedIndex].getAttribute('country-name');
      formTags.value += `,country_${country}`;

      const birthdate = this.form.querySelector("#birthday").value;
      formTags.value += `,birthdate_${birthdate}`;

      let gender = "";

      if (document.getElementById("gender#woman").checked) {
          gender = "woman";
      } else if (document.getElementById("gender#man").checked) {
          gender = "man";
      }

      // AT-814: salva cognome e numero di telefono
      if (lastName?.value) {
          formTags.value += `,last-name_${lastName.value}`;
      }

      if (phone?.value) {
          formTags.value += `,phone_${phone.value}`;
      }

      formTags.value += `,${gender}`;

      // Solo se sono nelle pagine degli store fisici
      if (nameStore != null && this.form.querySelector('.chose-boutiques .botiques') != null) {
          formTags.value += `,${nameStore.value}`;
          formTags.value += `,boutiquepreference_${this.form.querySelector('.botiques').options[this.form.querySelector('.botiques').selectedIndex].value.toLowerCase()}`;

          if (city?.value != '') {
              this.cityValue = new StringTransformer(city?.value).transform();
              formTags.value += `,city_${this.cityValue}`;
          }
      }

      e.preventDefault();
  }
}

if (!customElements.get('newsletter-form')) customElements.define('newsletter-form', NewsLetterForm)
